import ServiceBus from "servicestack/service-bus";
import basicController from "servicestack/basic.controller.properties";
import cartConfig from "emun.cart/cart.config";
// import moment from "moment";
import AutoQuery from "servicestack/auto-query/auto-query";

export default class VendorShipmentPromptController {
	constructor(options) {
		const $ctrl = this;
		basicController($ctrl);
		$ctrl.bus = new ServiceBus();
		$ctrl.config = cartConfig;
		$ctrl.order = Object.assign({}, options.model, options.order);
		$ctrl.title = options.title || "Enter Shipment Info";
		$ctrl.shipOn = moment();
		//$ctrl.trackingNumbers = [];
	}
	$onInit() {
		const $ctrl = this;
        $ctrl.bus.read('QueryCarts.json?IncludeProducts=1&Id=' + $ctrl.order.id).then(res=> {
            $ctrl.order = res.data.results[0];
        });
	}
	shipItemComplete(item) {
		let $ctrl = this;
		item.qtyShipped = item.qtyPurchased;
		return $ctrl.changeQuantity(item);
	}
	shipOrderComplete() {
		let $ctrl = this;
		$ctrl.order.items.forEach(function (item) {
			item.qtyShipped = item.qtyPurchased;
		});
	}
	decrementItem(item) {
		let $ctrl = this;
		item.qtyShipped -= 1;
		return $ctrl.changeQuantity(item);
	}

	incrementItem(item) {
		let $ctrl = this;
		item.qtyShipped += 1;
		return $ctrl.changeQuantity(item);
	}
	changeQuantity(item) {
		let $ctrl = this;
		let request = {
			id: $ctrl.order.id,
			cartId: $ctrl.order.id,
			productId: item.productId,
			quantity: item.qtyShipped,
			position: item.position
		};
		//return $ctrl.bus
		//.send("ChangeCartItemShipped.json", request);
	}
	save() {
		const $ctrl = this;
		let request = {
			cartId: $ctrl.order.id,
			shipOn: $ctrl.shipOn.format("MM/DD/YYYY"),
			trackingNumbers: $ctrl.trackingNumbers.split(','),
			items: $ctrl.order.items
		};
		$ctrl.bus.send('ApplyVendorShipment.json', request).then(function (response) {
			$ctrl.$close(response.data);
			$ctrl.$broadcast("$vendorShipmentApplied");
			//$ctrl.$state.transitionTo("orders.detail.shop", { orderId: response.data.id });
		});
	}
}
